module.exports = __webpack_public_path__ + "static/media/foreign-language-courses-in-delhi.d6fa6757.jpg";